import {
	SITE_ANALYTICS_OVERVIEW_CHART_EXPERIENCE,
	SITE_ANALYTICS_POPULAR_SPACES_CARD_EXPERIENCE,
	SITE_ANALYTICS_ACTIVE_READERS_CARD_EXPERIENCE,
	SITE_ANALYTICS_POPULAR_SEARCHES_CARD_EXPERIENCE,
	SITE_ANALYTICS_SPACES_TABLE_EXPERIENCE,
	SITE_ANALYTICS_USERS_TABLE_EXPERIENCE,
	SITE_ANALYTICS_SEARCH_TABLE_EXPERIENCE,
	SITE_ANALYTICS_SEARCH_PANEL_GRAPH_EXPERIENCE,
	SITE_ANALYTICS_SEARCH_PANEL_CONTENT_LIST_EXPERIENCE,
	SITE_ANALYTICS_SEARCH_PANEL_SPACES_LIST_EXPERIENCE,
} from '@confluence/experience-tracker/entry-points/ExperienceName.ts';

// The "Screen" name for all the analytics pages is the same! Their events are differentiated
// by attributes: level and type
export const SITE_ANALYTICS_SCREEN_ANALYTICS_SOURCE = 'analyticsPageScreen';
export const SITE_ANALYTICS_SEARCH_ANALYTICS_SOURCE = 'analyticsSearchScreen';
export const SITE_ANALYTICS_SCREEN_ANALYTICS_LEVEL = 'instance';
export const SITE_ANALYTICS_TABS_UI_ID = 'site-analytics-tabs';

// The order should represent the order in the UI
export enum SiteAnalyticsTab {
	'Overview',
	'Spaces',
	'Users',
	'Search',
}

// These exports are being duplicated in the SiteAnalytics/__playwright__/site-analytics-premium.spec.ts file as they
// cannot be imported; if changed, update there as well
export const MOST_ACTIVE_READERS_CARD_TEST_ID = 'site-analytics-active-readers-card';
export const MOST_ACTIVE_AGENTS_CARD_TEST_ID = 'site-analytics-active-agents-card';
export const OVERVIEW_CHART_TEST_ID = 'site-analytics-overview-chart';
export const OVERVIEW_CARDS_GRID_TEST_ID = 'site-analytics-overview-cards-grid';
export const POPULAR_SEARCHES_CARD_TEST_ID = 'site-analytics-popular-searches-card';
export const POPULAR_SPACES_CARD_TEST_ID = 'site-analytics-popular-spaces-card';
export const SEARCH_PANEL_CTR_CARD_TEST_ID = 'site-analytics-search-panel-ctr-card';
export const SEARCH_PANEL_MOST_CLICKED_CONTENT_CARD_TEST_ID =
	'site-analytics-search-panel-most-clicked-content-card';
export const SEARCH_PANEL_MOST_CLICKED_SPACES_CARD_TEST_ID =
	'site-analytics-search-panel-most-clicked-spaces-card';
export const SEARCH_PANEL_SEARCHES_CARD_TEST_ID = 'site-analytics-search-panel-searches-card';
// This export is being duplicated in the __playwright__/page-objects/ConfluenceAnalytics.ts file as it
// cannot be imported; if changed, update there as well
export const SEARCH_PANEL_TEST_ID = 'site-analytics-search-panel';
export const SEARCH_TABLE_TEST_ID = 'site-analytics-search-table';
export const SPACES_TABLE_TEST_ID = 'site-analytics-spaces-table';
export const USER_TABLE_TEST_ID = 'site-analytics-user-table';

export const SiteAnalyticsSubExperiences: {
	0: string[];
	1: string[];
	2: string[];
	3: string[];
} = {
	[SiteAnalyticsTab.Overview]: [
		SITE_ANALYTICS_OVERVIEW_CHART_EXPERIENCE,
		SITE_ANALYTICS_POPULAR_SPACES_CARD_EXPERIENCE,
		SITE_ANALYTICS_ACTIVE_READERS_CARD_EXPERIENCE,
		SITE_ANALYTICS_POPULAR_SEARCHES_CARD_EXPERIENCE,
	],
	[SiteAnalyticsTab.Spaces]: [SITE_ANALYTICS_SPACES_TABLE_EXPERIENCE],
	[SiteAnalyticsTab.Users]: [SITE_ANALYTICS_USERS_TABLE_EXPERIENCE],
	[SiteAnalyticsTab.Search]: [SITE_ANALYTICS_SEARCH_TABLE_EXPERIENCE],
};

export const SearchPanelSubExperiences: string[] = [
	SITE_ANALYTICS_SEARCH_PANEL_GRAPH_EXPERIENCE,
	SITE_ANALYTICS_SEARCH_PANEL_CONTENT_LIST_EXPERIENCE,
	SITE_ANALYTICS_SEARCH_PANEL_SPACES_LIST_EXPERIENCE,
];
